(() => {
  document.querySelectorAll('[data-field-guide]').forEach(root => {
    let dictionary={}; try { dictionary=JSON.parse(root.querySelector('[data-fg-i18n]')?.textContent||'{}'); } catch {}
    const t = source => dictionary[source] || source;
    const contents = root.querySelector('.fg-contents');
    const mobile = matchMedia('(max-width:768px)');
    const syncContents = () => { if (contents) contents.open = !mobile.matches; };
    syncContents(); mobile.addEventListener('change', syncContents);
    const offset = () => {
      const headers = [...document.querySelectorAll('[data-sticky-header], .shopify-section-header, #shopify-section-header, header.header, .header-middle')].filter(el => !root.contains(el));
      const nativeHeaderHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--height-header')) || 0;
      const bottom = Math.max(nativeHeaderHeight, ...headers.map(el => { const r=el.getBoundingClientRect(); const s=getComputedStyle(el); return (s.position==='sticky'||s.position==='fixed')&&r.top<=1 ? r.bottom : 0; }));
      root.style.setProperty('--fg-offset', `${Math.max(24, bottom+24)}px`);
    };
    offset(); window.addEventListener('resize', offset, {passive:true});
    root.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', () => {
      const target = root.querySelector(a.getAttribute('href'));
      if (!target) return;
      offset(); if (mobile.matches && contents?.contains(a)) contents.open=false;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
      requestAnimationFrame(() => { target.focus({preventScroll:true}); target.scrollIntoView({block:'start'}); });
    }));
    const chapterLinks = [...root.querySelectorAll('.fg-contents a')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const visible = entries.filter(x=>x.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top)[0];
        if (!visible) return;
        chapterLinks.forEach(a=>{ if(a.hash===`#${visible.target.id}`) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current'); });
      },{rootMargin:'-15% 0px -65% 0px'});
      root.querySelectorAll('.fg-prose h2[id]').forEach(el=>observer.observe(el));
    }
    const finder = root.querySelector('[data-finder]');
    if (!finder) return;
    finder.hidden=false;
    // The printed/no-JS link still reaches the complete situation directory.
    const openingStart = root.querySelector('[data-fg-opening-start]');
    if (openingStart) openingStart.setAttribute('href', '#routine-finder');
    const form=finder.querySelector('form'),result=finder.querySelector('[role="status"]');
    const routes = {
      fine:['fine-hair','Fine hair that feels weighed down'],dry:['oily-roots-dry-ends','Oily roots, dry ends'],curly:['curls-and-waves','Curls, waves and coils'],treated:['bleached-and-treated','Bleached, coloured and heat-styled lengths'],residue:['hard-water-residue','Hard water, residue and an unfamiliar finish'],new:['first-solid-shampoo','Your first solid-shampoo washes']
    };
    const addLink = ([id,label]) => {
      const a=document.createElement('a');const route=root.querySelector(`[data-fg-route="${id}"]`);
      if (!route) return;
      a.href=route.getAttribute('href');a.textContent=route.querySelector('strong')?.textContent.trim() || t(label);
      const row=document.createElement('p');row.append(a);result.append(row);
    };
    form.addEventListener('submit',event=>{
      event.preventDefault();result.replaceChildren();
      const scalp=form.elements.namedItem('scalp').value,length=form.elements.namedItem('length').value;
      const h=document.createElement('h3');h.textContent=scalp==='symptoms'?t('Start with the skin concern'):t('Your reading route');result.append(h);
      const text=document.createElement('p');text.textContent=scalp==='symptoms'?t('Itch and flakes can have different causes. Read the scalp-care route before making a cosmetic product choice.'): t('Read the scalp and length questions separately. These are practical starting points, not a product prescription.');result.append(text);
      if(scalp==='symptoms'){addLink(['itch-and-flakes','Itch, tightness and flakes']);return;}
      const seen=new Set();
      const add=r=>{if(!seen.has(r[0])){seen.add(r[0]);addLink(r);}};
      if(scalp==='oily')add(['oily-roots-dry-ends','Oily roots, dry ends']);
      if(scalp==='frequent')add(['frequent-washing','Frequently washed hair']);
      add(routes[length]);
    });
    form.addEventListener('change',()=>result.replaceChildren());
    form.addEventListener('reset',()=>{result.replaceChildren();requestAnimationFrame(()=>form.querySelector('input[name="scalp"]:checked')?.focus());});
  });
})();
